import { render, staticRenderFns } from "./pointDetails.vue?vue&type=template&id=28773225&scoped=true&"
import script from "./pointDetails.vue?vue&type=script&lang=js&"
export * from "./pointDetails.vue?vue&type=script&lang=js&"
import style0 from "./pointDetails.vue?vue&type=style&index=0&id=28773225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28773225",
  null
  
)

export default component.exports